// Чистите помощници около записано изписване, общи за началния екран, справката
// и документния модал: анулиран ли е, етикетът на вида и числата, които влизат
// в сумите (анулираните НЕ влизат).
import type { TFunction } from "i18next";
import type { Writeoff } from "../../../../api/inventory";
import { writeoffReasonKey } from "../../../../api/inventoryWriteoffReasons";
import { AUTO_SCRAP_REASON, WRITEOFF_REASONS } from "./writeoffWorksheetShared";

// Стар BE не праща `status` → документът е активен
export const isWriteoffAnnulled = (writeoff: Writeoff) =>
  writeoff.status === "annulled" || !!writeoff.deletedAt;

// Вид на документа — обща страница за изписване и бракуване
export const writeoffKindLabel = (writeoff: Pick<Writeoff, "kind">, t: TFunction) =>
  t(writeoff.kind === "scrap" ? "inventoryPage.scrap" : "inventoryPage.writeoff");

// Причината за брак се пази с каноничната си BG стойност → етикетът се
// локализира; свободният текст на изписването се показва както е написан.
// Сравнението е по ключа (малки букви, свити интервали) — „изтекъл срок" пак е
// предефинираната причина.
export const reasonLabelOf = (reason: string, t: TFunction) => {
  const key = writeoffReasonKey(reason);
  if (key === writeoffReasonKey(AUTO_SCRAP_REASON)) return t("inventoryPage.scrapReasonVoidMarking");
  const preset = WRITEOFF_REASONS.find((option) => writeoffReasonKey(option.value) === key);
  return preset ? t(`inventoryPage.${preset.key}`) : reason;
};

// Ключ → изписването от НАЙ-НОВИЯ документ (по дата, после по №) — етикетът на
// групата във филтъра „Причина", където няколко изписвания са ЕДНА причина.
export const reasonSpellingsOf = (writeoffs: Writeoff[]) => {
  const latest = new Map<string, Writeoff>();
  for (const writeoff of writeoffs) {
    const key = writeoffReasonKey(writeoff.reason);
    if (!key) continue;
    const current = latest.get(key);
    if (
      !current ||
      writeoff.date > current.date ||
      (writeoff.date === current.date && writeoff.id > current.id)
    )
      latest.set(key, writeoff);
  }
  return new Map([...latest].map(([key, writeoff]) => [key, (writeoff.reason ?? "").trim()]));
};

// Сумите по активните документи (KPI, редът „Общо", началният екран)
export const sumActiveWriteoffs = (writeoffs: Writeoff[]) => {
  const active = writeoffs.filter((writeoff) => !isWriteoffAnnulled(writeoff));
  return {
    count: active.length,
    net: active.reduce((sum, writeoff) => sum + (writeoff.totalValueNoVat || 0), 0),
    gross: active.reduce((sum, writeoff) => sum + (writeoff.totalValueWithVat || 0), 0),
    products: active.reduce((sum, writeoff) => sum + (writeoff.productsCount || 0), 0),
  };
};
